import React, { useState, useEffect} from "react";
import Card from "components/PurpleTheme/Card";
import { useDispatch, useSelector } from "react-redux";
import Select from 'react-select'
import { customStyles } from "helpers/component_helpers";

import {getActionItemById, getUsers, updateActionItemStatus, updateRcaHeaderDetails} from "store/actions";
import { Link } from "react-router-dom";

const ActionItemDetails = ({actionItemId}) => {
  const dispatch = useDispatch();
  const [ allUsers, setAllUsers ] = useState({});

  const { users } = useSelector(state => ({ users: state.Organization.users || []}));
  
  const { action_item } = useSelector(state => ({action_item: state.Rca.action_item}));
  const [dateState, setDateState] = useState(null);
  useEffect(() => {
    dispatch(getUsers())
  }, [getUsers, dispatch])

  useEffect(() => {
    const updatedUsers = {};
  
    users?.forEach((item) => {
      updatedUsers[item.id] = {
        id: item.id,
        name: item.name,
      };
    });
  
    setAllUsers(updatedUsers);
  }, [users.length, getUsers, dispatch, action_item]);

  useEffect(() => {
    dispatch(getActionItemById(actionItemId))
  }, [actionItemId,dispatch])

  useEffect(() => {
    setStatus(statusOptions.find(option => option.value === action_item.status) || null);
  }, [action_item, actionItemId])

  const statusOptions = [
    { value: "Pending", label: "Pending" },
    { value: "InProgess", label: "In Progress"},
    { value: "Completed", label: "Completed"},
  ]

  const [status, setStatus] = useState(
    statusOptions.find(option => option.value === action_item.status) || null
  );

  const formatDate = (timestamp) => {
    if (!timestamp) return '';
    const date = new Date(timestamp); // Parse the timestamp
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${day}-${month}-${year}`;
  }

  useEffect(() => {
    if(action_item.done_date){
      setDateState(action_item.done_date);
    }
  },[action_item,dispatch,updateActionItemStatus,users.length,allUsers.length]);

  return(
  <React.Fragment>
    <div className="w-75 mt-3">
    <div className="d-flex justify-content-start mb-3">
      <Link to="/RCA?tab=ActionItems">
        <span><i className="bx bx-arrow-back font-size-22 text-white" /></span>
      </Link>
      </div>
    <Card>
      <div className="d-flex w-100 gap-5">
        <div className="w-50">
          <table className="table-purple-org">
            <tbody className="table-dark">
              <tr>
                <td scope="row">
                  Name            
                </td>
                <td>{action_item?.title}</td>
              </tr>
              <tr>
                <td scope="row">Status</td>
                <td>{action_item?.status}</td>
              </tr>
              <tr>
                <td scope="row">Due date</td>
                <td>{formatDate(action_item?.target_date)}</td>
              </tr>
              <tr>
                <td scope="row">Assigned to</td>
                <td>{allUsers[action_item?.assigned_to]?.name}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="w-50">
          <table className="table-purple-org">
            <tbody className="table-dark">
              <tr>
                <td scope="row">Parent RCA</td>
                <td> <Link to={`/rca-form/${action_item?.rca?.id}`}>
                    {action_item?.rca?.title}
                  </Link> 
                </td>
              </tr>
              <tr>
                <td scope="row">Label</td>
                <td>{action_item?.type}</td>
              </tr>
              <tr>
                <td scope="row">Done date</td>
                <td>{action_item?.done_date ? formatDate(dateState) :  '-'}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="w-100 mt-5">
        <div className="d-inline-block w-25 ms-2">
          {action_item.status !== "Completed" ? (
              <div>
                <div>
                  <span>Change Status</span>
                </div>
                <div className="w-75 mt-2">
                  <Select
                      value={status}
                      options={statusOptions}
                      onChange={(selectedOption) => {
                        setStatus(selectedOption);
                        dispatch(
                            updateActionItemStatus({
                              action_item_id: actionItemId,
                              status: selectedOption.value,
                            })
                        );
                      }}
                      placeholder="Status"
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 0,
                        colors: {
                          ...theme.colors,
                          neutral0: "#222736",
                          neutral5: "#485EC4",
                          neutral10: "#485EC4",
                          neutral60: "#ffffff",
                          neutral70: "#ffffff",
                          neutral80: "#ffffff",
                          neutral90: "#ffffff",
                          primary: "#485EC4",
                        },
                      })}
                      styles={customStyles}
                  />
                </div>
              </div>
          ) : null}
        </div>
      </div>
      <div className="mt-5 ms-2">
        <span>Description</span>
        <p>{action_item?.description}</p>
      </div>
    </Card> 
    </div>
  </React.Fragment>
  )
}

export default ActionItemDetails;